import React from 'react';
import { useNavigate } from 'react-router-dom';



const GoogleSearch = () => {
    const [state, setState] = React.useState('');

    const navigate = useNavigate();
    const searchGoogle = async (e) => {
        // transfert in target value on submit state
        navigate("/SearchResults", { state: state });
        // transfert in target value on submit state

        console.log(state,"State");
      
    };
    return (
        <div>
            <h1>Home Page</h1>
            <h3>{state}</h3>
            <form className='gooelsearch' onSubmit={searchGoogle}>
                <input type="text" className='home_input' 
                onChange={(e) => setState(e.target.value)} 
                value={state}/>
                <input type="submit" className='home_btn' value="Google Search"/>
            </form>
        </div>
    );
};


export default GoogleSearch;